// URL path segments for the /webview/report/:reportType/:id routes.
export const ReportTypes = Object.freeze({
  USER: "user",
  COMMENT: "comment",
  STORY: "story",
  PUBLIC_MESSAGE: "public-message",
  MEDIA: "media"
});
